import { render, staticRenderFns } from "./HuaxianOtherFinance.vue?vue&type=template&id=636878b2&scoped=true&"
import script from "./HuaxianOtherFinance.vue?vue&type=script&lang=js&"
export * from "./HuaxianOtherFinance.vue?vue&type=script&lang=js&"
import style0 from "./HuaxianOtherFinance.vue?vue&type=style&index=0&id=636878b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636878b2",
  null
  
)

export default component.exports